import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    PAYOUT_RECIPIENTS_FAILURE,
    PAYOUT_RECIPIENTS_LOAD,
    PAYOUT_RECIPIENTS_SUCCESS
} from './payoutRecipientsActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                payoutRecipients: []
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_RECIPIENTS_LOAD:
            newState = {
                ...state,
                payoutRecipients: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_RECIPIENTS_SUCCESS:
            newState = {
                ...state,
                payoutRecipients: action.payoutRecipients,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_RECIPIENTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPayoutRecipientsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payoutRecipients')
);

export const getPages = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'count')
);

export const getIsPayoutRecipientsLoading = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'loading')
);

export const getPayoutRecipients = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'payoutRecipients')
);

export const getPayoutRecipientsError = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'error')
);

export const getPayoutRecipientsErrorMessage = createSelector(
    getPayoutRecipientsError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getPayoutRecipientsEntity,
    (entity) => get(entity, 'hasMore')
);
